// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_modal__KJgWl {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.modal_overlay__UdSge {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.modal_modalContent__aGcdT {
  max-width: 298px;
  width: 100%;
  padding: 24px;
  background-color: var(--tg-theme-bg-color);
  border-radius: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--color-error);
  border: 1px solid var(--tg-theme-hint-color);
  z-index: 100;
}
.modal_modalContent__aGcdT.modal_error__xvcZu {
  border: 3px solid var(--color-error);
  color: var(--color-error);
}

.modal_text__jD4lj {
  margin-bottom: 16px;
  color: var(--tg-theme-text-color);
}`, "",{"version":3,"sources":["webpack://./src/entities/modal/modal.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,4CAAA;EACA,YAAA;AAAF;AACE;EACE,oCAAA;EACA,yBAAA;AACJ;;AAGA;EACE,mBAAA;EACA,iCAAA;AAAF","sourcesContent":["\n.modal {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.overlay {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.modalContent {\n  max-width: 298px;\n  width: 100%;\n  padding: 24px;\n  background-color: var(--tg-theme-bg-color);\n  border-radius: 24px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: var(--color-error);\n  border: 1px solid var(--tg-theme-hint-color);\n  z-index: 100;\n  &.error {\n    border: 3px solid var(--color-error);\n    color: var(--color-error)\n  }\n}\n\n.text {\n  margin-bottom: 16px;\n  color:var(--tg-theme-text-color)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal_modal__KJgWl`,
	"overlay": `modal_overlay__UdSge`,
	"modalContent": `modal_modalContent__aGcdT`,
	"error": `modal_error__xvcZu`,
	"text": `modal_text__jD4lj`
};
export default ___CSS_LOADER_EXPORT___;
